var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 183.338,
    viewBox: "0 0 200 183.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(-0.001 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(0.001 27.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(0 32.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M52.08,97A31.2,31.2,0,0,1,22.563,75.742l-.292-.958A30.4,30.4,0,0,1,20.83,65.75V8.932L.612,76.417A18.926,18.926,0,0,0,13.879,99.376l128.861,34.509a19.111,19.111,0,0,0,4.8.617,18.58,18.58,0,0,0,18.009-13.625L173.058,97Z",
    transform: "translate(-0.001 -8.932)",
    fill: "rgba(0,0,0,0.1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M23.667,38.334A16.667,16.667,0,1,0,7,21.667,16.684,16.684,0,0,0,23.667,38.334Z",
    transform: "translate(51.33 -5)",
    fill: "rgba(0,0,0,0.1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M149.837,2h-125A20.863,20.863,0,0,0,4,22.834V114.5a20.863,20.863,0,0,0,20.834,20.834h125A20.863,20.863,0,0,0,170.671,114.5V22.834A20.863,20.863,0,0,0,149.837,2Zm-125,16.667h125A4.168,4.168,0,0,1,154,22.834v59.16L127.678,51.276A14.926,14.926,0,0,0,116.5,46.151a14.572,14.572,0,0,0-11.134,5.258L74.418,88.56,64.335,78.5a14.626,14.626,0,0,0-20.667,0l-23,22.992V22.834a4.168,4.168,0,0,1,4.167-4.167Z",
    transform: "translate(29.33)",
    fill: "rgba(0,0,0,0.1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image_placeholder.ea7f03d096c2c24549927561804f752c.svg";
export { ForwardRef as ReactComponent };